module.exports = __webpack_public_path__ + "static/media/validAccess.61d3e43c.mp3";